import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultiSelectDropdownModule } from '../../components/multi-select-dropdown/multi-select-dropdown.component';
import { CheckboxModule } from '../../components/checkbox/checkbox.component';
import { CircleButtonModule } from '../../components/circle-button/circle-button.component';
import { SharedModule } from '../../shared/shared.module';
import { IndustryContentCarouselModule } from '../industry-content-carousel/industry-content-carousel.module';
import { IndustryAddTopicComponent } from './industry-add-topic/industry-add-topic.component';
import { IndustryContentEmptyCarouselComponent } from './industry-content-empty-carousel/industry-content-empty-carousel.component';
import { IndustryContentModalWarningComponent } from './industry-content-modal-warning/industry-content-modal-warning.component';
import { IndustryContentSectionComponent } from './industry-content-section.component';
import { IndustryContentSelectorComponent } from './industry-content-selector/industry-content-selector.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IndustryContentCarouselModule,
    CircleButtonModule,
    CheckboxModule,
    MultiSelectDropdownModule,
  ],
  declarations: [
    IndustryContentSectionComponent,
    IndustryContentSelectorComponent,
    IndustryContentModalWarningComponent,
    IndustryContentEmptyCarouselComponent,
    IndustryAddTopicComponent,
  ],
  exports: [IndustryContentSectionComponent],
  entryComponents: [IndustryContentModalWarningComponent],
})
export class IndustryContentSectionModule {}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-content-section.module.ts